module.exports = __webpack_public_path__ + "c44ef45156fe82f469c126d31238baa4.jpg";